module.exports = __webpack_public_path__ + "img/25_72.31bedbc1.png";